import styled from 'styled-components';

interface Props {
  label: string;
  value: string | number;
}

const BookingInfoItem = ({ label, value }: Props) => (
  <div className="Grid Grid--alignMiddle u-mb05">
    <div className="Grid-cell u-size1of3">
      <div className="u-fsSmMd">{label}</div>
    </div>
    <div className="Grid-cell u-size2of3">
      <Crossable className="u-fsSmMd u-textRight u-textSemiBold">
        <span>{value}</span>
      </Crossable>
    </div>
  </div>
);

const Crossable = styled.div`
  &.overrideValue {
    color: #8e9697;
    text-decoration: line-through;
  }
`;

export default BookingInfoItem;
